if (!customElements.get('ov-garment-details')) {
  customElements.define('ov-garment-details', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const source = data.html.getElementById(this.id);
        if (!source) return;
        const wasOpen = this.querySelector('details')?.open;
        this.innerHTML = source.innerHTML;
        if (wasOpen) this.querySelector('details').open = true;
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
